import { parseNumber } from '../../../common';

function percentage(percent, total) {
  return parseNumber((parseNumber(total) * parseNumber(percent)) / 100, 2);
}

export default percentage;
